import React, {useState, useEffect} from 'react';
import useUserContext from '../common/UserContext';
import Recipients from '../program/Recipients';

import AddBenefitForm from '../program/AddBenefitForm';

export default function AddBenefit() {
	
	let [identifier, setIdentifier] = useState();
	let [addParms, setAddParms] = useState({});

	let copyId = (id) => {
		setIdentifier(id);
	};
	let getId = () => identifier;

	return (
		<>
		<h3>Issue Benefit</h3>

		<AddBenefitForm admin={true} getId={getId} programUuid={addParms.programUuid} agencyUuid={addParms.agencyUuid}/>
		<br/>
		<hr/>
		<Recipients searchOnly={true} copyId={copyId} admin={true} setAddParms={setAddParms}/>
		</>
	)
}
